"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const api_external_contract_js_1 = require("@tableau/api-external-contract-js");
const api_shared_js_1 = require("@tableau/api-shared-js");
const Parameter_1 = require("../Models/Parameter");
const ServiceRegistryUtil_1 = require("../Services/ServiceRegistryUtil");
const TableauSheetEvent_1 = require("./TableauSheetEvent");
class ParameterChangedEvent extends TableauSheetEvent_1.TableauSheetEvent {
    constructor(_globalFieldName, sheet) {
        super(api_external_contract_js_1.TableauEventType.ParameterChanged, sheet);
        this._globalFieldName = _globalFieldName;
    }
    getParameterAsync() {
        // Call down to our service to get the parameter back via its field name
        const service = api_shared_js_1.ApiServiceRegistry.get(ServiceRegistryUtil_1.ExtensionsRegistryId).getService("parameters-service" /* Parameters */);
        return service.findParameterByGlobalFieldNameAsync(this._globalFieldName).then((parameterImpl) => {
            if (parameterImpl === undefined) {
                throw new api_shared_js_1.TableauError(api_external_contract_js_1.ErrorCodes.MissingParameter, `Cannot find parameter: ${this._globalFieldName}`);
            }
            return new Parameter_1.Parameter(parameterImpl, this.sheet);
        });
    }
}
exports.ParameterChangedEvent = ParameterChangedEvent;
//# sourceMappingURL=ParameterChangedEvent.js.map